import React, { useState, useRef, useEffect, useContext } from 'react';

import axios from "axios";

// Contextos, helpers y utilidades desde tu módulo central
import {
    projectContext,
    loadingContext,
    urlValue,
    unfolder,
    openAlert,
    useTranslate,
    downloadFileFromFolder
} from '../../lib';

import { useForm } from 'react-hook-form'
import Swal from 'sweetalert2'
import { Tooltip } from 'react-tooltip'
import { SelectNesting } from '../common/Inputs/Select'
import { CustomChat } from '../CustomChat'
import BoxInfo from '../common/BoxInfo'
import { Alerts } from '../common/Alerts'

// Componentes hijos
import ContactDriverForm from './SettingsOptionsGenAIChildren/ContactDriverForm';
import AIPersonaDetails from './SettingsOptionsGenAIChildren/AIPersonaDetails';
import EvaluationSettings from './SettingsOptionsGenAIChildren/EvaluationSettings';
import CallSettings from './SettingsOptionsGenAIChildren/CallSettings';
import VoiceSettings from './SettingsOptionsGenAIChildren/VoiceSettings';
import ChatSettings from './SettingsOptionsGenAIChildren/ChatSettings';
import SimulationSettings from './SettingsOptionsGenAIChildren/SimulationSettings';
import LLMSettings from './SettingsOptionsGenAIChildren/LLMSettings';

export default function SettingsOptionsGenAI({
    role, setRole,
}) {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm()

    const { t } = useTranslate();

    const formRef = useRef(null);
    const name_ref = useRef();
    const description_ref = useRef();
    const language_ref = useRef();
    const handleAvatarChange = () => { };
    const campaign_ref = useRef();
    const subcampaing_ref = useRef();
    const industry_ref = useRef();
    const welcome_mesageRef = useRef();
    const closing_mesageRef = useRef();
    const model_llm_ref = useRef();
    const temperature_ref = useRef();
    const top_p_ref = useRef();
    const top_k_ref = useRef();
    const max_token_ref = useRef();
    const url_simulationRef = useRef();
    const Simulation_Step_number_ref = useRef();
    const timeHoldRef = useRef();
    const timeHoldAmountRef = useRef();
    const minimunCallDurations = useRef();
    const maximunCallDurations = useRef();
    const model_sentiment_ref = useRef();
    const phrases_list_ref = useRef();
    const bot_respose_time_ref = useRef();
    const contact_driver_context_ref = useRef();
    const contact_driver_example_ref = useRef();
    const contact_driver_other_ref = useRef();
    const minimum_passing_score_ref = useRef();
    const contact_driver_role_ref = useRef();
    const contact_driver_task_ref = useRef();
    const contact_driver_rules_ref = useRef();
    const contact_driver_forbidden_actions_ref = useRef();
    const contact_driver_default_fallback_ref = useRef();
    const voice_ref = useRef();
    const logsQuestions = useRef('');
    const sentimentBotRef = useRef();
    const affectation_time_ref = useRef();
    const percentage_affectation_ref = useRef();
    const gender_bot_avatar_ref = useRef();
    const maxUserResponseTime_ref = useRef();
    const fetchAvatarRequestRef = useRef(null);
    const migratingPromptRef = useRef(false);

    // States
    const [channel, setChannel] = useState("voice")
    const [category, setCategory] = useState('');
    const [showClosing, setShowClosing] = useState(false);
    const [hold, setHold] = useState(false);
    const [showSimulationSetting, setShowSimulationSetting] = useState(false);
    const [showChatSetting, setShowChatSetting] = useState(false);
    const [simulationStatus, setSimulationStatus] = useState(false);
    const [bot_sentiment, setBot_sentiment] = useState(false);
    const [assistedSimulation, setAssistedSimulation] = useState(false);
    const [phrasesList, setPhrasesList] = useState('');
    const [maxUserResponseTime, setMaxUserResponseTimeValue] = useState('');
    const [chat_typing_simulating, setChat_typing_simulating] = useState(false);
    const [avatarSentimentPreview, setAvatarSentimentPreview] = useState(null);
    const [uploadingAvatarSentiment, setUploadingAvatarSentiment] = useState(false);
    const [showAiPersonaDetails, setShowAiPersonaDetails] = useState(false);
    const [personaMood, setPersonaMood] = useState('friendly');
    const [personaTalkativeMood, setPersonaTalkativeMood] = useState('medium');
    const [personaResponseLength, setPersonaResponseLength] = useState(200);
    const [showEvaluation, setShowEvaluation] = useState(false);
    const [showCallSettings, setShowCallSettings] = useState(false);
    const [showVoicesSetting, setShowVoicesSetting] = useState(false);
    const [questions, setQuestions] = useState([]);
    const [useValueQuestion, setUseValueQuestion] = useState(false);
    const [overwriteSubcampaign, setOverwriteSubcampaign] = useState(false);
    const [categoriesApi, setCategoriesApi] = useState([]);
    const [loadingCategories, setLoadingCategories] = useState(false);
    const [contactDriverForm, setContactDriverForm] = useState(false);
    const [useNewPrompt, setUseNewPrompt] = useState(0);
    const [showCampaignSettings, setShowCampaignSettings] = useState(true);
    const [transcription, setTranscription] = useState(0);
    const [campaings, setCampaings] = useState([])
    const [subCampaings, setSubCampaings] = useState([])
    const [selectedProject, setSelectedProject] = useContext(projectContext)
    const [translationAssessment, setTranslationAssessment] = useState(selectedProject.otherLenguage === 1)
    const [selectedSubCampaignId, setSelectedSubCampaignId] = useState(null);
    const [alert, setAlert] = useState({ title: '', visible: false })
    const [radomVoice, setRadomVoice] = useState(false)
    const modelSentiment_ref = useRef();
    const [genderBotAvatar, setGenderBotAvatar] = useState('male')
    const [selectedChatOption, setSelectedChatOption] = useState(0);
    const [avatarFile, setAvatarFile] = useState(null)
    const [loading, setLoading] = useContext(loadingContext)
    const [language, setLanguage] = useState(selectedProject.metadata.language);
    const [timeHold, setTimeHold] = useState(0);
    const [amountTimeHold, setAmountTimeHold] = useState(0);
    const [useDefaultSentiment, setUseDefaultSentiment] = useState(0);
    const [modelSentiment, setModelSentiment] = useState('Voice');
    const [bot_respose_time, setBot_respose_time] = useState(0);
    const [uploadingAvatar, setUploadingAvatar] = useState(false)
    const [voices, setVoices] = useState([])
    const [textToPlay, setTextToPlay] = useState('')
    const [showCustomChatForm, setShowCustomChatForm] = useState(false);
    const [showLLMSetting, setShowLLMSetting] = useState(false);
    const [customChats, setCustomChats] = useState([]);
    const [avatarError, setAvatarError] = useState(false)
    const [avatarPreview, setAvatarPreview] = useState(null)
    const [customEvaluation, setCustomEvaluation] = useState({
        evaluations: [],
        selected_custom_evaluation_id: null,
        grammar_criteria: ["all"]
    });

    const industries = [
        { id: 1, name: "BFSI" },
        { id: 2, name: "Gaming" },
        { id: 3, name: "News & Media" },
        { id: 4, name: "Tech App Food & Delivery" },
        { id: 5, name: "Tech-Home Services" },
        { id: 6, name: "Telecom" },
        { id: 7, name: "Travel & Hospitality" },
        { id: 8, name: "Other" },
    ]

    useEffect(() => {
        (async () => {
            setRole(unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').role)
            await fetchVoice();
            await fetchCampaing();
            const subCampaingsData = await fetchSubCampaing();
            await fetchCustomChats();
            await fetchCategories();
            const projectData = await getProject();
            const projectId = selectedProject.id
            fetchAvatarRequestRef.current = projectId
            let fetched = null
            try {
              fetched = await fetchAvatarForProject(projectId)
            } catch (err) {
              console.warn('fetchAvatarForProject failed', err)
            }
            if (fetchAvatarRequestRef.current === projectId) {
              if (fetched && fetched.url) {
                setAvatarPreview(fetched.url)
              } else {
                setAvatarPreview(null)
              }
              fetchAvatarRequestRef.current = null
            }

            if (projectData?.data?.sub_campaing_id && subCampaingsData.data.length > 0) {

                const selectedSubCampaign = subCampaingsData.data.find(
                    subCampaign => subCampaign.id === parseInt(projectData.data.sub_campaing_id)
                );
                if (selectedSubCampaign) {
                    setSelectedSubCampaignId(selectedSubCampaign.id);
                    setPhrasesList(convertPhrasesListToString(selectedSubCampaign.phrases_list || ''));
                }
            }

        })()

    }, []);

    const fetchVoice = async () => {
        let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
        let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
        const project_id = selectedProject.id;

        try {
            const url = `${urlValue}/studio/project/voices/all`;
            const rest = await axios.get(url, {
                headers: {
                    user: id,
                    language: language.substring(0, 2) || 'EN',
                    'access-token': token,
                    'Content-Type': 'application/json',
                    'project_id': project_id
                },
            });

            if (rest.status === 200 && rest.data) {
                setVoices(rest.data.data)
                //setTimeout(()=>{document.querySelector("#voice").value = selectedProject.voice_id },700);
            }
            return rest;
        } catch (error) {
            console.log(error)
            return error;
        }
    }

    const fetchCategories = async () => {
        setLoadingCategories(true);
        try {
            let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
            let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
            let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken;
            const response = await axios({
                method: 'get',
                url: `${urlValue}/studio/categories`,
                headers: {
                    'access-token': token,
                    user: id,
                    'X-CSRF-Token': csrfToken,
                },
                withCredentials: true,
            });
            setCategoriesApi(response.data || []);
        } catch (err) {
            setCategoriesApi([]);
            console.log('Error fetching categories:', err);
        }
        setLoadingCategories(false);
    };

    const fetchCampaing = async () => {
        let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
        let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
        // setLoading(true)
        try {
            const url = `${urlValue}/studio/campaign/campaignsUser`
            const rest = await axios.get(url, {
                headers: {
                    user: id,
                    'access-token': token,
                    'Content-Type': 'application/json',
                },
            });

            if (rest.status === 200 && rest.data) {
                setCampaings(rest.data)
            }
            return rest;;
        } catch (error) {
            console.log(error)
            return error;
        }
    }

    const fetchSubCampaing = async () => {
        let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
        let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
        // setLoading(true)
        try {
            const url = `${urlValue}/studio/campaign/subcampaignsUser`
            const rest = await axios.get(url, {
                headers: {
                    user: id,
                    'access-token': token,
                    'Content-Type': 'application/json',
                },
            });

            if (rest.status === 200 && rest.data) {
                setSubCampaings(rest.data)
            }
            return rest;
        } catch (error) {
            console.log(error)
            return error;
        }
    }

    const convertPhrasesListToString = (phrasesListJson) => {
        try {
            if (!phrasesListJson) {
                return '';
            }
            let phrasesList
            if (typeof phrasesListJson === 'string') {
                try {
                    phrasesList = JSON.parse(phrasesListJson)
                }
                catch (e) {
                    console.log("No es un JSON String")
                    return phrasesListJson;
                }
            }
            else {
                phrasesList = phrasesListJson;
            }

            return Array.isArray(phrasesList)
                ? phrasesList.map(item => item.phrase).join(';')
                : '';
        } catch (error) {
            console.error('Error converting phrases list:', error);
            return '';
        }
    };

  useEffect(() => {
    const current = avatarPreview
    return () => {
      try {
        if (current && typeof current === 'string' && current.startsWith('blob:')) {
          URL.revokeObjectURL(current)
        }
      } catch (e) { /* ignore */ }
    }
  }, [avatarPreview])

  const fetchAvatarForProject = async (projectId) => {
    try {
      const resp = await axios.get(`${urlValue}/studio/avatar`, {
        headers: {
          'access-token': unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token,
          'client-id': projectId,
          'folder': 'agents',
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache'
        },
        responseType: 'blob',
        validateStatus: (status) => status >= 200 && status < 500,
      })

      if (resp && resp.status === 200 && resp.data && resp.data instanceof Blob) {
        const url = URL.createObjectURL(resp.data)
        return { type: 'blob', url }
      }

      if (resp && resp.data && typeof resp.data === 'object' && resp.data.url) {
        return { type: 'url', url: resp.data.url }
      }

      return null

    } catch (err) {
      console.warn('Avatar could not be loaded from server', err)
      return null
    }
  }

    const saveProject = (e) => {

        const aiPersonaDetails = {
            mood: personaMood,
            responseLength: personaResponseLength,
            talkativeMood: personaTalkativeMood
        };
        console.log('AI Persona Details:', aiPersonaDetails);

        e.preventDefault();
        let ok = true
        let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
        let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
        let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
        let valueTotal = 0
        const name = selectedProject.name;
        const campaignIdTemp = (campaign_ref.current?.value || 0) == 0 ? selectedProject.campaing : campaign_ref.current?.value;
        const subCampaignIdTemp = (subcampaing_ref.current?.value || 0) == 0 ? selectedProject.sub_campaing : subcampaing_ref.current?.value;

        const exp = /^[A-Za-z0-9-,._'\s]+$/g;
        if (!exp.test(name)) {
            ok = false;
            openAlert('#alert-ac', () => { setAlert({ title: t('errors.nameInvalid'), visible: true, error: true }) }, 4000, () => { setAlert({ ...alert, visible: false }) });
        }

        if ((campaignIdTemp || 0) == 0 || (subCampaignIdTemp || 0) == 0) {
            ok = false;
            openAlert('#alert-ac', () => { setAlert({ title: t('alerts.selectCampaignSubcampaign'), visible: true, error: true }) }, 4000, () => { setAlert({ ...alert, visible: false }) });
        }

        if (useValueQuestion == 1) {
            for (let i = 0; i < questions.length; i++) {
                if ((parseFloat(questions[i].value) || 0) <= 0) {
                    ok = false;
                    openAlert('#alert-ac', () => { setAlert({ title: t('alerts.valueQuestions'), visible: true, error: true }) }, 4000, () => { setAlert({ ...alert, visible: false }) });
                    break;
                }
                valueTotal = valueTotal + parseFloat(questions[i].value)
            }

            if (valueTotal != 100) {
                ok = false;
                openAlert('#alert-ac', () => { setAlert({ title: t('alerts.valueQuestions'), visible: true, error: true }) }, 4000, () => { setAlert({ ...alert, visible: false }) });
            }
        }

        const invalidQuestions = questions.filter((q) => q.question.includes('"'));
        if (invalidQuestions.length > 0) {
            ok = false;
            openAlert('#alert-ac', () => { setAlert({ title: t('alerts.doubleQuotesQuestions'), visible: true, error: true }) }, 4000, () => { setAlert({ ...alert, visible: false }) });
        }

        const countAutofail = questions.filter(q => q.autofail === 1).length;
        if (countAutofail > 1) {
            ok = false;
            openAlert('#alert-ac', () => { setAlert({ title: 'No puedes tener dos marcadas', visible: true, error: true }) }, 4000, () => { setAlert({ ...alert, visible: false }) });
        }

        if ((top_k_ref.current?.value || 0) < 0 || (top_k_ref.current?.value || 0) > 250) {
            ok = false;
            openAlert('#alert-ac', () => { setAlert({ title: t('alerts.topKValue'), visible: true, error: true }) }, 4000, () => { setAlert({ ...alert, visible: false }) });
        }

        const minCallTime = Number(minimunCallDurations.current?.value || 0);
        const maxCallTime = Number(maximunCallDurations.current?.value || 0);
        if (minCallTime > maxCallTime) {
            ok = false;
            openAlert(
                '#alert-ac',
                () => setAlert({ title: t('alerts.valideMaxAndMinCall'), visible: true, error: true }),
                4000,
                () => setAlert({ ...alert, visible: false })
            );
        }
        const emojiRole = containsEmoji(contact_driver_role_ref?.current?.value)
        const emojiTask = containsEmoji(contact_driver_task_ref?.current?.value)
        const emojiContext = containsEmoji(contact_driver_context_ref?.current?.value)
        const emojiRules = containsEmoji(contact_driver_rules_ref?.current?.value)
        const emojiForbidden = containsEmoji(contact_driver_forbidden_actions_ref?.current?.value)
        const emojiDefault = containsEmoji(contact_driver_default_fallback_ref?.current?.value)
        const emojiExample = containsEmoji(contact_driver_example_ref?.current?.value)
        const emojiOther = containsEmoji(contact_driver_other_ref?.current?.value)

        if (emojiRole || emojiTask || emojiContext || emojiRules || emojiForbidden || emojiForbidden || emojiDefault
            || emojiExample || emojiOther) {
            ok = false;
            openAlert(
                '#alert-ac',
                () => setAlert({ title: t('alerts.validateEmoji'), visible: true, error: true }),
                4000,
                () => setAlert({ ...alert, visible: false })
            );
        }

        if (avatarError) {
          ok = false;
          openAlert('#alert-ac', () => { 
            setAlert({ title: t('alerts.fixAvatarErrors'), visible: true, error: true }) 
          }, 4000, () => { setAlert({ ...alert, visible: false }) });
        }

        if (ok) {

            savePhrasesListSubCampaign();

            //quito el id temporal
            const cleanedQuestions = questions?.map(({ id, ...rest }) => rest);
            const voiceIdTemp = (voice_ref.current?.value || 0) == 0 ? selectedProject.voice_id : voice_ref.current?.value;
            const campaignIdTemp = (campaign_ref.current?.value || 0) == 0 ? selectedProject.campaing : campaign_ref.current?.value;
            const subCampaignIdTemp = (subcampaing_ref.current?.value || 0) == 0 ? selectedProject.sub_campaing : subcampaing_ref.current?.value;

            const dataSend = {
                id: selectedProject.id,
                name: selectedProject.name,
                //Se cambio a null temporalmente hasta la primera entrega despues agregar id de cada nlp Dlowflow RASA
                nlp: selectedProject.nlp,
                nlp_url: selectedProject.nlp_url,
                metadata: { "description": selectedProject.metadata.description, "language": selectedProject.metadata.language },
                //Se cambio a null temporalmente hasta la primera entrega despues /agregar la imagen
                image: selectedProject.image,
                hold: hold,
                time_hold_amount: timeHoldAmountRef.current?.value || 0,
                time_hold_seconds: timeHoldRef.current?.value || 0,
                use_hold: hold ? 1 : 0,
                channel: channel,
                random_voice: radomVoice ? 1 : 0,
                use_default_sentiment: selectedProject.use_default_sentiment,
                bot_sentiment: selectedProject.bot_sentiment,
                model_sentiment: modelSentiment_ref.current?.value,
                url_tp_simulation: url_simulationRef.current?.value,
                simulation_status: simulationStatus,
                category: category,
                outbound_call: category === 'outbound' ? 1 : 0,
                transcription: transcription,
                campaing: campaignIdTemp,
                sub_campaing: subCampaignIdTemp,
                voice: voiceIdTemp,
                type: selectedProject.type,
                contact_driver_role: contact_driver_role_ref?.current?.value,
                contact_driver_task: contact_driver_task_ref?.current?.value,
                contact_driver_context: contact_driver_context_ref?.current?.value,
                contact_driver_rules: contact_driver_rules_ref?.current?.value,
                contact_driver_forbidden_actions: contact_driver_forbidden_actions_ref?.current?.value,
                contact_driver_default_fallback: contact_driver_default_fallback_ref?.current?.value,
                contact_driver_example: contact_driver_example_ref?.current?.value,
                contact_driver_other: contact_driver_other_ref?.current?.value,
                use_new_prompt: migratingPromptRef.current ? 1 : useNewPrompt,
                contact_driver_config: aiPersonaDetails,
                evaluation_questions: cleanedQuestions,
                industry: (customEvaluation.selected_custom_evaluation_id && customEvaluation.selected_custom_evaluation_id > 0) 
                    ? 'Custom' 
                    : industry_ref.current?.value,
                custom_evaluation: customEvaluation.evaluations.length > 0 ? {
                    evaluations: customEvaluation.evaluations,
                    selected_custom_evaluation_id: customEvaluation.selected_custom_evaluation_id
                } : null,
                grammar_criteria: Array.isArray(customEvaluation.grammar_criteria) 
                    ? customEvaluation.grammar_criteria.join(',') 
                    : customEvaluation.grammar_criteria,
                welcome_msg: welcome_mesageRef?.current?.value || selectedProject.welcome_msg,
                closing_msg: closing_mesageRef?.current?.value || selectedProject.closing_msg,
                min_call_time: minimunCallDurations.current?.value || 0,
                max_call_time: maximunCallDurations.current?.value || 0,
                max_user_response_time: maxUserResponseTime.current?.value || 0,
                bot_response_time: bot_respose_time_ref.current?.value || 1,
                gender_bot_avatar: gender_bot_avatar_ref.current?.value || 'male',
                num_simulation_steps: Simulation_Step_number_ref.current?.value || 1,
                assisted_simulation: assistedSimulation,
                custom_chat: selectedChatOption,
                model_llm: model_llm_ref.current?.value || selectedProject.model_llm,
                temperature: temperature_ref.current?.value || selectedProject.temperature,
                top_p: top_p_ref.current?.value || selectedProject.top_p,
                top_k: top_k_ref.current?.value || selectedProject.top_k,
                minimum_passing_score: minimum_passing_score_ref.current?.value || 70,
                use_value_question: useValueQuestion,
                otherLenguage: 0,
                logsQuestions: logsQuestions.current,
            }
            axios({
                method: 'post',
                url: `${urlValue}/studio/project/update`,
                headers: {
                    user: id,
                    'access-token': token,
                    'X-CSRF-Token': csrfToken
                },
                withCredentials: true,
                data: dataSend,
            })
                .then(async function (response) {
                    migratingPromptRef.current = false;
                    
                    setSelectedProject({
                        ...selectedProject,
                        channel: channel,
                        voice_id: voice_ref.current?.value || selectedProject?.voice_id,
                        campaing: campaign_ref.current?.value,
                        sub_campaing: subcampaing_ref.current?.value,
                        time_hold_amount: timeHoldAmountRef.current?.value || 0,
                        time_hold_seconds: timeHoldRef.current?.value || 0,
                        use_hold: hold ? 1 : 0,
                        random_voice: radomVoice ? 1 : 0,
                        type: selectedProject.type,
                        model_sentiment: modelSentiment_ref.current?.value,
                        industry: industry_ref.current?.value || 'Other',
                        // problem: problem_ref.current?.value,
                        // solution: solucion_ref.current?.value,
                        contact_driver_role: contact_driver_role_ref?.current?.value,
                        contact_driver_task: contact_driver_task_ref?.current?.value,
                        contact_driver_context: contact_driver_context_ref?.current?.value,
                        contact_driver_rules: contact_driver_rules_ref?.current?.value,
                        contact_driver_forbidden_actions: contact_driver_forbidden_actions_ref?.current?.value,
                        contact_driver_default_fallback: contact_driver_default_fallback_ref?.current?.value,
                        contact_driver_example: contact_driver_example_ref?.current?.value,
                        contact_driver_other: contact_driver_other_ref?.current?.value,
                        contact_driver_config: aiPersonaDetails,

                        evaluation_questions: questions,

                        welcome_msg: welcome_mesageRef?.current?.value || selectedProject.welcome_msg,
                        closing_msg: closing_mesageRef?.current?.value || selectedProject.closing_msg,
                        url_tp_simulation: url_simulationRef.current?.value,
                        simulation_status: simulationStatus,
                        category: category,
                        outbound_call: category === 'outbound' ? 1 : 0,
                        min_call_time: minimunCallDurations.current?.value || 0,
                        max_call_time: maximunCallDurations.current?.value || 0,
                        max_user_response_time: maxUserResponseTime.current?.value || 0,
                        bot_response_time: bot_respose_time_ref.current?.value || 1,
                        gender_bot_avatar: gender_bot_avatar_ref.current?.value || 'male',
                        num_simulation_steps: Simulation_Step_number_ref.current?.value || 1,
                        assisted_simulation: assistedSimulation,
                        custom_chat: selectedChatOption,
                        model_llm: model_llm_ref.current?.value || 'Sonnetv2',
                        temperature: temperature_ref.current?.value || 0.1,
                        top_p: top_p_ref.current?.value || 0.2,
                        top_k: top_k_ref.current?.value || 20,
                        minimum_passing_score: minimum_passing_score_ref.current?.value || 70,
                        use_value_question: useValueQuestion,
                        otherLenguage: 0,
                    })
                    logsQuestions.current = ''
                    openAlert('#alert-ac', () => { setAlert({ title: t('alerts.settingsSaved'), visible: true }) }, 4000, () => { setAlert({ ...alert, visible: false }) });
                    getProject();
                    if (avatarFile) {
                        await uploadAvatar(avatarFile)
                    }
                    setLoading(false)
                })
                .catch(function (error) {
                    openAlert('#alert-ac', () => { setAlert({ title: t('alerts.settingsNotSaved'), visible: true, error: true }) }, 4000, () => { setAlert({ ...alert, visible: false }) });
                    console.error("error ", error)
                })
        }
    }

      const fetchProjectsBySubcampaign = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
    const campaignId = (campaign_ref.current?.value || 0) == 0 ? selectedProject.campaing : campaign_ref.current?.value;
    const subcampaignId = (subcampaing_ref.current?.value || 0) == 0 ? selectedProject.sub_campaing : subcampaing_ref.current?.value;

    if (!campaignId || !subcampaignId) {
      return [];
    }

    try {
      const res = await axios.get(
        `${urlValue}/studio/project/campaign/${campaignId}/projects`,
        {
          headers: {
            user: id,
            'access-token': token,
            'Content-Type': 'application/json',
          },
          withCredentials: true,
        }
      );
      const body = res.data;
      const allProjects = Array.isArray(body) ? body
        : Array.isArray(body?.data) ? body.data
        : Array.isArray(body?.projects) ? body.projects
        : [];
      // Filter by subcampaign on frontend
      return allProjects.filter(p => String(p.sub_campaing_id) === String(subcampaignId));
    } catch (error) {
      console.error('Error fetching projects by subcampaign', error);
      return [];
    }
  };

  const overwriteSubcampaignProjects = async (loadedQuestions) => {
    setLoading(true);
    const projects = await fetchProjectsBySubcampaign();

    if (projects.length === 0) {
      setLoading(false);
      openAlert('#alert-ac', () => {
        setAlert({ title: t('alerts.noProjectsInSubcampaign') || 'No projects found in this subcampaign', visible: true, error: true });
      }, 4000, () => { setAlert({ ...alert, visible: false }); });
      return;
    }

    setLoading(false);

    const projectListHtml = projects
      .map(p => `<li style="text-align:left;margin:4px 0">${p.name} <small style="color:#888">(ID: ${p.id})</small></li>`)
      .join('');

    const result = await Swal.fire({
      title: t('menu.confirmation'),
      html: `
        <p style="margin-bottom:10px"><strong>${projects.length}</strong> ${t('menu.genai.projectsWillBeUpdated') || 'project(s) will be updated'}:</p>
        <ul style="max-height:200px;overflow-y:auto;padding-left:20px;list-style:disc">${projectListHtml}</ul>
        <p style="margin-top:12px;color:#d33;font-weight:bold">
          ⚠️ ${t('alerts.overwriteWarning') || 'This will overwrite the evaluation questions and industry of all listed projects.'}
        </p>
      `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#6c757d',
      confirmButtonText: t('common.yes') + ', Overwrite',
      cancelButtonText: t('common.no'),
      width: 600,
    });

    if (!result.isConfirmed) return;

    setLoading(true);
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken;
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;

    const cleanedQuestions = loadedQuestions.map(({ id: qId, ...rest }) => rest);

    try {
      const promises = projects.map(proj => {
        const projMetadata = (typeof proj.metadata === 'string' && proj.metadata) ? JSON.parse(proj.metadata) : (proj.metadata || {});
        const projImage = (typeof proj.image === 'string' && proj.image) ? JSON.parse(proj.image) : (proj.image || null);
        return axios({
          method: 'post',
          url: `${urlValue}/studio/project/update`,
          headers: {
            user: id,
            'access-token': token,
            'X-CSRF-Token': csrfToken,
          },
          withCredentials: true,
          data: {
            id: proj.id,
            name: proj.name,
            nlp: proj.nlp,
            nlp_url: proj.nlp_url || 'none',
            metadata: { description: projMetadata.description || 'none', language: projMetadata.language || 'EN' },
            image: projImage,
            type: proj.type,
            channel: proj.channel || 'voice',
            category: proj.category || 'outbound',
            evaluation_questions: cleanedQuestions,
            industry: industry_ref.current?.value,
            use_value_question: useValueQuestion,
          },
        });
      });
      

      await Promise.all(promises);
      openAlert('#alert-ac', () => {
        setAlert({ title: `${projects.length} ${t('alerts.projectsOverwritten') || 'project(s) overwritten successfully'}`, visible: true });
      }, 4000, () => { setAlert({ ...alert, visible: false }); });
    } catch (error) {
      console.error('Error overwriting projects', error);
      openAlert('#alert-ac', () => {
        setAlert({ title: t('alerts.settingsNotSaved'), visible: true, error: true });
      }, 4000, () => { setAlert({ ...alert, visible: false }); });
    } finally {
      setLoading(false);
    }
  };

    const showContactDriverForm = (value) => {
        setContactDriverForm(value);
    };

    const handleAvatarSentimentChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setUploadingAvatarSentiment(true);
            const reader = new FileReader();
            reader.onloadend = () => {
                setAvatarSentimentPreview(reader.result);
                setUploadingAvatarSentiment(false);
            };
            reader.readAsDataURL(file);
        }
    };

    const getProject = async () => {
        let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
        let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id

        setLoading(true)
        try {
            const response = await axios({
                method: 'get',
                url: `${urlValue}/studio/project/${selectedProject.id}`,
                headers: {
                    user: id,
                    'access-token': token,
                    'Content-Type': 'application/json',
                },
            })

            setSelectedProject(response.data)

            // document.getElementById('url_tp_simulation').value = response.data.url_tp_simulation;
            // document.getElementById('bot_sentiment').value = response.data.bot_sentiment;

            setLanguage(response.data.metadata.language);
            setTimeHold(response.data.TimeSecondHold);
            setAmountTimeHold(response.data.AmountTimeHold);
            setRadomVoice(response.data.random_voice);
            setHold(response.data.useHold);
            setUseDefaultSentiment(response.data.use_default_sentiment)
            setTranscription(response.data.transcription)
            // setCategory(response.data.category)
            setCategory(response.data.outbound_call === 1 ? "outbound" : "inbound")
            setChannel(response.data.channel)

            setUseDefaultSentiment(response.data.use_default_sentiment)
            setTimeHold(response.data.TimeSecondHold)
            setAmountTimeHold(response.data.AmountTimeHold)
            setModelSentiment(response.data.model_sentiment)
            setUseValueQuestion(response.data.use_value_question || selectedProject?.use_value_question)
            const initialQuestions = response.data?.gen_ai.evaluation_questions?.map((q, i) => ({
                ...q,
                id: `${i}-${Date.now()}`,
                category: q.category || "Greeting",
                autofail: q.autofail || 0,
            }))
            setQuestions(initialQuestions || []);
            setAssistedSimulation(selectedProject.assisted_simulation)
            setSimulationStatus(selectedProject?.simulation_status)
            setTranslationAssessment(response.data.otherLenguage === 1);
            setMaxUserResponseTimeValue(response.data.max_user_response_time || 0);
            setBot_respose_time(response.data.bot_response_time || 0);
            setGenderBotAvatar(response.data.gender_bot_avatar || 'male')

            if (voice_ref.current && response.data.voice_id) {
                voice_ref.current.value = response.data.voice_id;
            } else {
                console.warn('voice_ref or voice_id is undefined');
            }
            industry_ref.current.value = response.data?.gen_ai?.industry || 'Other';
            
            // Cargar evaluación personalizada y grammar criteria si existen
            const customEval = response.data?.gen_ai?.custom_evaluation;
            const grammarCrit = response.data?.gen_ai?.grammar_criteria;
            
            // Convertir grammar_criteria de string a array si es necesario
            let grammarCriteriaArray = ['all'];
            if (grammarCrit) {
                if (typeof grammarCrit === 'string') {
                    grammarCriteriaArray = grammarCrit.split(',').map(c => c.trim()).filter(c => c);
                } else if (Array.isArray(grammarCrit)) {
                    grammarCriteriaArray = grammarCrit;
                }
            }
            
            setCustomEvaluation({
                evaluations: customEval?.evaluations || [],
                selected_custom_evaluation_id: customEval?.selected_custom_evaluation_id || null,
                grammar_criteria: grammarCriteriaArray
            });
            
            // problem_ref.current.value = response.data?.gen_ai.problem;
            // solucion_ref.current.value = response.data?.gen_ai.solution;
            if (contact_driver_role_ref.current) {
                contact_driver_role_ref.current.value = response.data?.gen_ai.contact_driver_role;
            }
            if (contact_driver_task_ref.current) {
                contact_driver_task_ref.current.value = response.data?.gen_ai.contact_driver_task;
            }
            if(response.data?.gen_ai?.use_new_prompt){
                setUseNewPrompt(response.data?.gen_ai?.use_new_prompt);
            }
            if (contact_driver_context_ref.current) {
                contact_driver_context_ref.current.value = response.data?.gen_ai.contact_driver_context;
            }
            if (contact_driver_rules_ref.current) {
                contact_driver_rules_ref.current.value = response.data?.gen_ai.contact_driver_rules;
            }

            if (contact_driver_forbidden_actions_ref.current) {
                contact_driver_forbidden_actions_ref.current.value = response.data?.gen_ai?.contact_driver_forbidden_actions;
            }

            if (contact_driver_default_fallback_ref.current) {
                contact_driver_default_fallback_ref.current.value = response.data?.gen_ai?.contact_driver_default_fallback;
            }

            if (contact_driver_example_ref.current) {
                contact_driver_example_ref.current.value = response.data?.gen_ai?.contact_driver_example;
            }

            if (contact_driver_other_ref.current) {
                contact_driver_other_ref.current.value = response.data?.gen_ai?.contact_driver_other;
            }

            if (campaign_ref.current) {
                campaign_ref.current.value = response.data.campaing_id;
            }

            if (subcampaing_ref.current) {
                subcampaing_ref.current.value = response.data.sub_campaing_id;
            }

            if (modelSentiment_ref.current) {
                modelSentiment_ref.current.value = response.data.model_sentiment;
            }

            if (timeHoldRef.current) {
                timeHoldRef.current.value = response.data.TimeSecondHold;
            }

            if (timeHoldAmountRef.current) {
                timeHoldAmountRef.current.value = response.data.AmountTimeHold;
            }

            if (url_simulationRef.current) {
                url_simulationRef.current.value = response.data.url_tp_simulation;
            }

            if (Simulation_Step_number_ref?.current) {
                Simulation_Step_number_ref.current.value = response.data.num_simulation_steps;
            }

            if (welcome_mesageRef.current) {
                welcome_mesageRef.current.value = response.data.welcome_msg;
            }

            if (minimunCallDurations.current) {
                minimunCallDurations.current.value = response.data.min_call_time || 0;
            }

            if (maximunCallDurations.current) {
                maximunCallDurations.current.value = response.data.max_call_time || 0;

                if ((response.data?.max_call_time || 0) !== 0) {
                    setShowClosing(true)
                }
            }

            if (closing_mesageRef.current) {
                closing_mesageRef.current.value = response.data.closing_msg;
            }

            if (model_llm_ref.current) {
                model_llm_ref.current.value = response.data.model_llm || 'claude';
            }

            if (temperature_ref.current) {
                temperature_ref.current.value = response.data.temperature || 0;
            }

            if (top_p_ref.current) {
                top_p_ref.current.value = response.data.top_p || 0;
            }

            if (top_k_ref.current) {
                top_k_ref.current.value = response.data.top_k || 0;
            }

            if (minimum_passing_score_ref.current) {
                minimum_passing_score_ref.current.value = response.data.minimum_passing_score || 70;
            }

            const cfgRaw =
                response.data?.gen_ai?.contact_driver_config ??
                response.data?.contact_driver_config;

            if (cfgRaw) {
                const cfg = typeof cfgRaw === 'string' ? JSON.parse(cfgRaw) : cfgRaw;

                if (cfg?.mood) setPersonaMood(cfg.mood); // 'friendly' | 'angry' | 'sad' | 'unfriendly' | 'excited' | 'calm'
                if (cfg?.responseLength) setPersonaResponseLength(cfg.responseLength); // 'short' | 'medium' | 'long'
                if (cfg?.talkativeMood) setPersonaTalkativeMood(cfg.talkativeMood);    // 'yes' | 'no'
            }

            setLoading(false)
            return response
        }
        catch (error) {
            console.log("Error GetProject", error)
            setLoading(false)
            return error;
        }

    }

    const onChangeStatusSimulation = () => {
        setSimulationStatus(prev => !prev);
    };

    const deleteQuestiong = (id) => {
        setQuestions(prev => prev.filter(q => q.id !== id));
    };

    const handleAutofailChange = (e, id) => {
        const { checked } = e.target;
        setQuestions(prev =>
            prev.map(q =>
                q.id === id ? { ...q, fail: checked } : q
            )
        );
    };

    const addQuestiong = () => {
        setQuestions(prev => [
            ...prev,
            { id: Date.now(), question: '', fail: false }
        ]);
    };

    const addCategoryModal = () => {
        // Logic placeholder: originally opens modal
        console.log('Modal to add category triggered');
    };

    const containsEmoji = (str) => {
        if (!str) return false;

        try {
            // Usa Unicode property escapes (mejor soporte en navegadores modernos)
            const re = /(\p{Emoji_Presentation}|\p{Extended_Pictographic})/u;
            return re.test(str);
        } catch (e) {
            // Fallback para navegadores antiguos
            const fallback = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;
            return fallback.test(str);
        }
    };

    const savePhrasesListSubCampaign = async () => {
        let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
        let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
        let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;

        // Clean phrases using regex to keep only letters, numbers and spaces
        const cleanPhrase = (phrase) => {
            return phrase.replace(/[^a-zA-Z0-9\s]/g, '').trim();
        };

        // Process phrases_list_ref into JSON format
        const phrasesListSend = phrasesList.split(';')
            .map((phrase, index) => ({
                id: index + 1,
                phrase: cleanPhrase(phrase)
            }))
            .filter(item => item.phrase !== '');

        const dataSend = {
            id: parseInt(subcampaing_ref.current.value),
            phrases_list: phrasesListSend
        };

        try {
            const response = await axios({
                method: 'post',
                url: `${urlValue}/studio/project/camp/sub-campaing/phrases-list/update`,
                headers: {
                    user: id,
                    'access-token': token,
                    'X-CSRF-Token': csrfToken
                },
                withCredentials: true,
                data: dataSend,
            });

            if (response.status === 200) {
                console.log('Phrases list updated successfully');
                // Update local state to reflect changes
                const updatedSubCampaings = subCampaings.map(subCamp => {
                    if (subCamp.id === parseInt(subcampaing_ref.current.value)) {
                        return { ...subCamp, phrases_list: phrasesList };
                    }
                    return subCamp;
                });
                setSubCampaings(updatedSubCampaings);
            }
        } catch (error) {
            console.error('Error updating phrases list:', error);
            openAlert('#alert-ac', () => {
                setAlert({
                    title: t('alerts.errorPhrasesList'),
                    visible: true,
                    error: true
                });
            }, 4000, () => {
                setAlert({ ...alert, visible: false });
            });
        }
    };

  const validateImageFile = (file) => {
    const allowed = ['image/jpeg', 'image/png']
    if (!allowed.includes(file.type)) return { ok: false, message: t('alerts.avatarInvalidType') }
    if (file.size > 100 * 1024) return { ok: false, message: t('alerts.avatarTooLarge') }
    return { ok: true }
  }


  const uploadAvatar = async (file) => {
    try {
      setUploadingAvatar(true)
      const form = new FormData()
      form.append('avatar', file)
      console.log('Uploading avatar for client-id:', selectedProject);
      await axios.post(`${urlValue}/studio/avatar`, form, {
        headers: { 
          'access-token': unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token,
          'X-CSRF-Token': unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken,
          'client-id': selectedProject.id,
          'folder': 'agents',
        },
        withCredentials: true,
      })
      openAlert('#alert-ac', () => { 
        setAlert({ title: t('alerts.avatarUploadSuccess'), visible: true }) 
      }, 4000, () => { setAlert({ ...alert, visible: false }) });
    } catch (e) {
      console.error('Avatar upload error', e)
      openAlert('#alert-ac', () => { 
        setAlert({ title: t('alerts.avatarUploadError') + ': ' + (e.response?.data?.message || e.message), visible: true, error: true }) 
      }, 4000, () => { setAlert({ ...alert, visible: false }) });
    } finally {
      setUploadingAvatar(false)
    }
  }

    const changeMaxCallDuration = (e) => {
        if (e.target.value == 0) {
            setShowClosing(false)
        } else {
            setShowClosing(true)
        }
    }

    const saveBotSentimentConfig = function (e) {
        let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
        let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
        let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken

        axios({
            method: 'post',
            url: `${urlValue}/studio/project/${selectedProject.id}/bot_sentiment`,
            headers: {
                user: id,
                'access-token': token,
                'X-CSRF-Token': csrfToken
            },
            withCredentials: true,
            data: {
                bot_sentiment: e.target.value,
            }
        }).then(function (res) {
            // console.log('res');
        }).catch(error => {
            console.log('Error to try update bot sentiment: ', error);
        })
    }

    const playVoice = async () => {
        let tokenN = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
        let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
        const selectedVoiceId = voice_ref.current?.value;
        const selectedVoice = voices.find(v => String(v.id) === String(selectedVoiceId));
        let voice = selectedVoice?.voice;
        if (!voice) {
            setAlert({ title: 'Select a valid voice', visible: true, error: true });
            return;
        }

        try {
            let url = `${process.env.REACT_APP_AZURE_ENDPOINT}/sts/v1.0/issuetoken`;
            const resToke = await axios.post(url, {}, {
                headers: {
                    'Ocp-Apim-Subscription-Key': process.env.REACT_APP_AZURE_SUBCRIPTION_KEY
                }
            });
            let token = resToke.data;

            const pitch = '0%';
            const style = 'general';
            const rate = '0%';
            const volume = '+0.00%';
            if (textToPlay.trim() !== '') {
                let speaker1 = `<speak version="1.0" xmlns="http://www.w3.org/2001/10/synthesis" 
                                xmlns:mstts="https://www.w3.org/2001/mstts" xml:lang="en-US">
                                      <voice name="${voice?.trim()?.replaceAll('_', '-')}">
                                          <prosody rate="${rate}" pitch="${pitch}" volume="${volume}">
                                              <mstts:express-as style="${style}">
                                                  ${textToPlay}
                                              </mstts:express-as>
                                          </prosody>
                                      </voice>
                                   </speak>`;
                try {
                    const res3 = await fetch('https://eastus.tts.speech.microsoft.com/cognitiveservices/v1', {
                        method: 'POST',
                        headers: {
                            'Ocp-Apim-Subscription-Key': process.env.REACT_APP_AZURE_SUBCRIPTION_KEY,
                            Authorization: `Bearer ${token}`,
                            'cache-control': 'no-cache',
                            'X-Microsoft-OutputFormat': 'riff-24khz-16bit-mono-pcm',
                            'Content-Type': 'application/ssml+xml'
                        },
                        body: speaker1
                    });
                    if (!res3.ok) {
                        throw new Error('Fetch failed!');
                    }
                    const wavFile = await res3.blob();
                    const audioUrl = URL.createObjectURL(wavFile);
                    const audio = new Audio(audioUrl);
                    audio.play();
                } catch (error) {
                    setAlert({ title: 'Error playing voice', visible: true, error: true });
                    console.log(error);
                }
            } else {
                setAlert({ title: 'Write a text to play', visible: true, error: true });
            }
        } catch (error) {
            setAlert({ title: 'Error getting Azure token', visible: true, error: true });
            console.log(error);
        }
    }

    const fetchCustomChats = async () => {
        const predefined = [
            { id: 0, name: 'Standard' },
            { id: 1, name: 'WhatsApp' },
            { id: 2, name: 'Telegram' },
        ];

        let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
        let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
        const project_id = selectedProject.id;

        try {
            const url = `${urlValue}/studio/project/customchats/all`;

            const rest = await axios.get(url, {
                headers: {
                    user: id,
                    'access-token': token,
                    'Content-Type': 'application/json',
                    'project_id': project_id
                },
            });

            if (rest.status === 200 && rest.data.data) {
                setCustomChats([...predefined, ...rest.data.data])
            }
            return rest.data.data;
        } catch (error) {
            setCustomChats(predefined)
            console.log(error)
            return error;
        }
    };

    const handleMigratePrompt = () => {
        const confirmed = window.confirm(
            t('menu.genai.migrateNewPromptIrreversibleConfirm')
        );

        if (!confirmed) return;

        migratingPromptRef.current = true; // 👈 fuente de verdad
        setUseNewPrompt(1);

        formRef.current?.requestSubmit();

    };

    return (
    <>
        <form ref={formRef} onSubmit={saveProject} className="settings-container w-100">

            {/* SECTION 1 - Call Information / ContactDriverForm */}
            <ContactDriverForm
                contactDriverForm={contactDriverForm}
                showContactDriverForm={showContactDriverForm}

                contact_driver_context_ref={contact_driver_context_ref}
                contact_driver_rules_ref={contact_driver_rules_ref}
                contact_driver_forbidden_actions_ref={contact_driver_forbidden_actions_ref}
                contact_driver_default_fallback_ref={contact_driver_default_fallback_ref}

                contact_driver_example_ref={contact_driver_example_ref}
                contact_driver_other_ref={contact_driver_other_ref}
                use_new_prompt={useNewPrompt}
                onMigratePrompt={handleMigratePrompt}
            />

            {/* SECTION 2 - AI Persona Details */}
            {useNewPrompt === 1 &&
                <AIPersonaDetails
                    showAiPersonaDetails={showAiPersonaDetails}
                    setShowAiPersonaDetails={setShowAiPersonaDetails}
                    personaMood={personaMood}
                    setPersonaMood={setPersonaMood}
                    personaTalkativeMood={personaTalkativeMood}
                    setPersonaTalkativeMood={setPersonaTalkativeMood}
                    personaResponseLength={personaResponseLength}
                    setPersonaResponseLength={setPersonaResponseLength}
                />
            }

            {/* SECTION 3 - Evaluation */}
            <EvaluationSettings
                showEvaluation={showEvaluation}
                setShowEvaluation={setShowEvaluation}
                questions={questions}
                setQuestions={setQuestions}
                useValueQuestion={useValueQuestion}
                setUseValueQuestion={setUseValueQuestion}
                categoriesApi={categoriesApi}
                setCategoriesApi={setCategoriesApi}
                loadingCategories={loadingCategories}
                deleteQuestiong={deleteQuestiong}
                handleAutofailChange={handleAutofailChange}
                addQuestiong={addQuestiong}
                addCategoryModal={addCategoryModal}
                industry_ref={industry_ref}
                customEvaluation={customEvaluation}
                setCustomEvaluation={setCustomEvaluation}
                channel={channel}
                overwriteSubcampaign={overwriteSubcampaign}
                setOverwriteSubcampaign={setOverwriteSubcampaign}
                overwriteSubcampaignProjects={overwriteSubcampaignProjects}
            />

            {/* SECTION 4 - Campaign & Message Settings */}
            <CallSettings
                showCallSettings={showCallSettings}
                setShowCallSettings={setShowCallSettings}

                channel={channel}
                setChannel={setChannel}

                category={category}
                setCategory={setCategory}
                welcome_mesageRef={welcome_mesageRef}

                transcription={transcription}
                setTranscription={setTranscription}

                translationAssessment={translationAssessment}
                setTranslationAssessment={setTranslationAssessment}

                selectedProject={selectedProject}
                setSelectedProject={setSelectedProject}

                subCampaings={subCampaings}
                setSubCampaings={setSubCampaings}

                campaings={campaings}
                setCampaings={setCampaings}

                selectedSubCampaignId={selectedSubCampaignId}
                setSelectedSubCampaignId={setSelectedSubCampaignId}

                campaign_ref={campaign_ref}
                subcampaing_ref={subcampaing_ref}

                minimum_passing_score_ref={minimum_passing_score_ref}

                industries={industries}

                avatarPreview={avatarPreview}

                handleAvatarChange={handleAvatarChange}
            />

            {/* SECTION 5 - Voices Setting */}
            {channel === 'voice' && (<VoiceSettings
                showCallSettings={showCallSettings}
                setTranscription={setTranscription}
                transcription={transcription}
                channel={channel}
                phrases_list_ref={phrases_list_ref}
                setPhrasesList={setPhrasesList}
                phrasesList={phrasesList}
                setHold={setHold}
                hold={hold}
                timeHoldAmountRef={timeHoldAmountRef}
                timeHoldRef={timeHoldRef}
                minimunCallDurations={minimunCallDurations}
                maximunCallDurations={maximunCallDurations}
                showClosing={showClosing}
                closing_mesageRef={closing_mesageRef}
                changeMaxCallDuration={changeMaxCallDuration}
                sentimentBotRef={sentimentBotRef}
                saveBotSentimentConfig={saveBotSentimentConfig}
                selectedProject={selectedProject}
                modelSentiment_ref={modelSentiment_ref}
                showVoicesSetting={showVoicesSetting}
                setShowVoicesSetting={setShowVoicesSetting}
                setRadomVoice={setRadomVoice}
                radomVoice={radomVoice}
                voice_ref={voice_ref}
                voices={voices}
                textToPlay={textToPlay}
                setTextToPlay={setTextToPlay}
                playVoice={playVoice}
            />)}

            {/* SECTION 6 - Chats Setting */}
            {channel === 'chat' && (
                <ChatSettings
                    showChatSetting={showChatSetting}
                    setShowChatSetting={setShowChatSetting}
                    channel={channel}
                    Tooltip={Tooltip}
                    register={register}
                    affectation_time_ref={affectation_time_ref}
                    selectedProject={selectedProject}
                    percentage_affectation_ref={percentage_affectation_ref}
                    maxUserResponseTime={maxUserResponseTime_ref}
                    setMaxUserResponseTimeValue={setMaxUserResponseTimeValue}
                    maxUserResponseTime_ref={maxUserResponseTime_ref}
                    bot_respose_time_ref={bot_respose_time_ref}
                    setBot_respose_time={setBot_respose_time}
                    gender_bot_avatar_ref={gender_bot_avatar_ref}
                    genderBotAvatar={genderBotAvatar}
                    SelectNesting={SelectNesting}
                    setSelectedChatOption={setSelectedChatOption}
                    setShowCustomChatForm={setShowCustomChatForm}
                    customChats={customChats}
                    showCustomChatForm={showCustomChatForm}
                    fetchCustomChats={fetchCustomChats}
                    CustomChat={CustomChat}
                />
            )}

            {/* SECTION 7 - Simulation settings */}
            <SimulationSettings
                showSimulationSetting={showSimulationSetting}
                setShowSimulationSetting={setShowSimulationSetting}
                simulationStatus={simulationStatus}
                onChangeStatusSimulation={onChangeStatusSimulation}
                url_simulationRef={url_simulationRef}
                Simulation_Step_number_ref={Simulation_Step_number_ref}
                assistedSimulation={assistedSimulation}
                setAssistedSimulation={setAssistedSimulation}
                BoxInfo={BoxInfo}
            />

            {/* SECTION 8 - LLM settings */}
            {role === 6 && (
                <LLMSettings
                    showLLMSetting={showLLMSetting}
                    setShowLLMSetting={setShowLLMSetting}
                    model_llm_ref={model_llm_ref}
                    temperature_ref={temperature_ref}
                    top_p_ref={top_p_ref}
                    top_k_ref={top_k_ref}
                    max_token_ref={max_token_ref}
                />
            )}

            {/* Save button */}
            <div className="mt-2" style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end'}}>
                <button className="create btn-primary btn-bottom btn-bottom-create" type="submit" style={{ backgroundColor: "#0087FF" }}>
                    {t('common.save')}
                </button>
            </div>
        </form>
        {alert.visible && <Alerts id="alert-ac" title={alert.title} error={alert.error} />}
    </>
    );
}
